import { observer } from 'mobx-react';
import { Checkbox } from 'antd';
import FormCommon from '@/components/FormCommon';
import { BaseItem } from '@/components/FormItem';
import { $fm } from '@/Intl';
import { useFitscreen } from '@/store';
import './index.less';

type FitKey = keyof ConfigFitScreen;

export default observer(() => {
  const [fitscreen, updateFitscreen, defaults] = useFitscreen();

  const keys = Object.keys(fitscreen) as FitKey[];

  return (
    <FormCommon
      onReset={() => {
        updateFitscreen(defaults);
      }}
    >
      <BaseItem label={$fm('APPLIST')}>
        <div className='app-list'>
          {keys.map((key) => (
            <div key={key}>
              <Checkbox
                checked={Boolean(fitscreen[key])}
                onChange={(e) => {
                  updateFitscreen({
                    [key]: Number(e.target.checked),
                  });
                }}
              >
                {key}
              </Checkbox>
            </div>
          ))}
        </div>
      </BaseItem>
    </FormCommon>
  );
});
